module.exports = __webpack_public_path__ + "img/baked-potato.ee9e259a.png";